import { z } from 'zod';
import { parseAsJson, parseAsStringEnum, useQueryStates } from 'nuqs';

const schema = z.object({
  id: z.string(),
  name: z.string(),
});

export const useHistoryDialogFilters = () => {
  const [filters, setFilters] = useQueryStates({
    sortOrder: parseAsStringEnum(['desc', 'asc']).withDefault('desc'),
    activeStep: parseAsJson(schema.parse),
  });

  return {
    filters,
    setFilters,
  };
};
